import React, { useCallback } from 'react';
import { useTheme } from 'styled-components';
import { Text, Button } from '../../mo-gel';
import { ReactComponent as RightArrow } from '../../images/icons/right_icon.svg';
import {
  StyledMainContainer,
  StyledContentHeading,
  StyledContent,
  StyledIcon,
  StyledActionContainer,
  StyledButtonContents
} from './TwoColumnTiles.styled';
import { researchPanels } from '../../contents/research';

export const TwoColumnTiles = () => {
  const theme = useTheme();

  const openLinkInNewTab = useCallback((url: string) => {
    window.open(url, '_blank');
  }, []);

  return (
    <StyledMainContainer>
      {researchPanels.map((panel: any, index: number) => (
        <StyledActionContainer key={index}>
          <StyledContent>
            <StyledIcon>
              <img src={panel.image} alt="Research" />
            </StyledIcon>
            <StyledContentHeading level="h5" align="center" marginTop="0" color={theme.colors.content}>
              {panel.title}
            </StyledContentHeading>
            <Text tag="p" level="normal" marginBottom="0" color={theme.colors.content}>
              {panel.text}
            </Text>
          </StyledContent>
          {panel.link !== '' && (
            <Button primary={true} width="244px" onClick={() => openLinkInNewTab(panel.link)}>
              <StyledButtonContents>
                {panel.linkText}
                <RightArrow />
              </StyledButtonContents>
            </Button>
          )}
        </StyledActionContainer>
      ))}
    </StyledMainContainer>
  );
};
